import { render, staticRenderFns } from "./ChessSect.vue?vue&type=template&id=3f04fc0d&scoped=true&"
import script from "./ChessSect.vue?vue&type=script&lang=js&"
export * from "./ChessSect.vue?vue&type=script&lang=js&"
import style0 from "./ChessSect.vue?vue&type=style&index=0&id=3f04fc0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04fc0d",
  null
  
)

export default component.exports